import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import {deleteACompany, loadCompanysData, saveACompany, updateACompany} from "../../redux/modules/company";
import {
	deleteAStoragelot,
	loadStoragelotsData,
	saveAStoragelot,
	updateAStoragelot,
	clearStoragelotErrorMsg,
} from "../../redux/modules/storagelot";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import InputMask from 'react-input-mask'


//import {loadCompanysData} from "../../redux/modules/company";


import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
//import {loadCamerasData} from "../../redux/modules/camera";
import {withStyles} from "@material-ui/core";
import DynamicTable from "./DynamicTable";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import GridList from "@material-ui/core/GridList";
import CardVehicleInformation from "./CardVehicleInformation";
import CardCompanyInformation from "./CardCompanyInformation";
import CardStorageLotInformation from "./CardStorageLotInformation";
import FormHelperText from "@material-ui/core/FormHelperText";
import * as MainConstants from "../../utils/MainConstants";
import ExpandableStorageLotInformation from "./ExpandableStorageLotInformation";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
//import {loadLocationsData} from "../../redux/modules/location";


const styles = theme => ({
	main: {
		width: 'auto',
		display: 'block', // Fix IE 11 issue.
		marginLeft: theme.spacing.unit * 3,
		marginRight: theme.spacing.unit * 3,
		[theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
			width: 400,
			marginLeft: 'auto',
			marginRight: 'auto',
		},
	},
	paper: {
		marginTop: theme.spacing.unit * 8,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
	},
	avatar: {
		margin: theme.spacing.unit,
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing.unit,
	},
	submit: {
		marginTop: theme.spacing.unit * 3,
	},
	formControl: {
		margin: theme.spacing.unit,
		minWidth: 120,
	},
	selectEmpty: {
		marginTop: theme.spacing.unit * 2,
	},
	button: {
		marginTop: theme.spacing.unit * 3,
		marginLeft: theme.spacing.unit,
		backgroundColor: "#e2580d",
		color: "black",
		textTransform: "unset !important",
		width: '80%'
	},
	gridList: {
		width: '90%',
		height: '100%',
		maxHeight: 800,
	},
});


/*
private String id;
	private String ein;
	private String userId;
	private String name;
	private String address1;
	private String address2;
	private String city;
	private String state;
	private String country;
	private String zipCode;
	private String type;
	private String phone;
	private String email;
 */

class StorageLotInfoForm extends React.Component {
	
	
	state = {
		
		//selectedLocation:{},
		selectedStoragelot: {"id":""},
		selectedCompany: {},
		selectedState: "Massachusetts",
		selectedCountry: "U.S.A",
		inputFieldShrinkState: true,
		numberShrink: false, //Jut sfor alter I can add a shrink flag for each filed.
		showStoragelotSavedDialog: false,
		storagelotsArray: [],
		
	};
	
	/*
	
	private String id;
private String accountName;
private String accountNumber;
private String bankName;
private String address1;
private String address2;
private String city;
private String state;
private String country;
private String zipCode;
private String accountRoutingNumber;
private String companyId;
private String userId;
private String phone;
	
	 */
	
	constructor(props) {
		super(props);
		this.storageCardList = null;
		this.editRecord = this.editRecord.bind(this);
		this.deleteRecord = this.deleteRecord.bind(this);
		this.clearFields = this.clearFields.bind(this);
		this.refresh = this.refresh.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleUpdate = this.handleUpdate.bind(this);
		//this.handleCompanyNumberChange = this.handleCompanyNumberChange.bind(this);
		this.handleNameChange = this.handleNameChange.bind(this);
		this.handleAddress1Change = this.handleAddress1Change.bind(this);
		//this.handleBankNameChange = this.handleBankNameChange.bind(this);
		
		this.handleAddress2Change = this.handleAddress2Change.bind(this);
		
		this.handleCityChange = this.handleCityChange.bind(this);
		this.handleStateChange = this.handleStateChange.bind(this);
		this.handleCountryChange = this.handleCountryChange.bind(this);
		this.handleZipcodeChange = this.handleZipcodeChange.bind(this);
		this.handleEmailChange = this.handleEmailChange.bind(this);
		this.handleLocationChange = this.handleLocationChange.bind(this);
		this.handlePhoneChange = this.handlePhoneChange.bind(this);
		
		this.handleFaxChange = this.handleFaxChange.bind(this);
		this.handleTypeChange = this.handleTypeChange.bind(this);
		this.handleTimeZoneChange = this.handleTimeZoneChange.bind(this);
		this.handleLogoChange = this.handleLogoChange.bind(this);
		this.handleWebChange = this.handleWebChange.bind(this);
		this.handleCompanyChange = this.handleCompanyChange.bind(this);
		this.handleStateSelectionChange = this.handleStateSelectionChange.bind(this);
		this.handleCountrySelectionChange = this.handleCountrySelectionChange.bind(this);
		this.getListOfSrorageInformationExpandable = this.getListOfSrorageInformationExpandable.bind(this);
		
		this.handleClickShowSavedStoragelot = this.handleClickShowSavedStoragelot.bind(this);
		this.handleClickShowSavedStoragelotClose = this.handleClickShowSavedStoragelotClose.bind(this);
		this.checkFieldsForBlank = this.checkFieldsForBlank.bind(this);
		
	}
	
	
	checkFieldsForBlank(argPoliceFields){
		
		if(argPoliceFields !== null ){
			
			if( (argPoliceFields.name == null)||(argPoliceFields.name ==="")){
				alert("Please enter the storage name" );
				return -1;
			}
			/*if( (argPoliceFields.departmentname == null)||(argPoliceFields.departmentname ==="")){
				alert("Please enter the Department Name" );
				return -1;
			}*/
			if( (argPoliceFields.address1 == null)||(argPoliceFields.address1 ==="")){
				alert("Please enter the Address Line 1" );
				return -1;
			}
			/*if( (tempStream.address2 == null)||(tempStream.address2 =="")){
					alert("Please enter the Department Name" );
					return;
			}*/
			if( (argPoliceFields.city == null)||(argPoliceFields.city ==="")){
				alert("Please enter the City" );
				return -1;
			}
			if( (argPoliceFields.zipcode == null)||(argPoliceFields.zipcode ==="")){
				alert("Please enter the Zipcode" );
				return -1;
			}
			if( (argPoliceFields.phone == null)||(argPoliceFields.phone ==="")){
				alert("Please enter the Phone" );
				return -1;
			}
			
			if( (argPoliceFields.fax == null)||(argPoliceFields.fax ==="")){
				alert("Please enter the Fax" );
				return -1;
			}
			if( (argPoliceFields.country == null)||(argPoliceFields.country ==="")){
				alert("Please enter the Country" );
				return-1;
			}
			
			if( (argPoliceFields.email == null)||(argPoliceFields.email ==="")){
				alert("Please enter the Email" );
				return -1;
			}
			if( (argPoliceFields.state == null)||(argPoliceFields.state ==="")){
				alert("Please enter the State" );
				return -1;
			}
			
		}else{
			alert("Please enter the fields" );
			return -1;
		}
		
		return 0;
	}
	handleClickShowSavedStoragelot() {
		this.setState({showStoragelotSavedDialog: true});
	};
	
	
	handleClickShowSavedStoragelotClose() {
		let {clearStoragelotErrorMsg} = this.props;
		this.setState({showStoragelotSavedDialog: false});
		clearStoragelotErrorMsg();
	};
	
	handleSubmit() {
		
		
		let {saveAStoragelot} = this.props;
		
		var tempStream = this.state.selectedStoragelot;
		tempStream.state = this.state.selectedState;
		tempStream.country = this.state.selectedCountry
		if ((tempStream.address2 == null) || (tempStream.address2.length == 0)) {
			tempStream.address2 = "  ";
		}
		let checkFieldsResult = this.checkFieldsForBlank(tempStream);
		if((checkFieldsResult === -1)){
			return;
		}
		saveAStoragelot(DEFAULT_VESPAAN_SERVER.url, tempStream, this.state.selectedCompany.id);
		
		
	};
	
	handleUpdate() {
		let {updateAStoragelot} = this.props;
		
		var tempStream = this.state.selectedStoragelot;
		tempStream.state = this.state.selectedState;
		tempStream.country = this.state.selectedCountry;
		tempStream.companyid = this.state.selectedCompany.id;
		updateAStoragelot(DEFAULT_VESPAAN_SERVER.url, tempStream, this.state.selectedCompany.id);
		//this.refresh();
		
	};
	
	handleZipcodeChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedStoragelot, {zipcode: event.target.value}));
	}
	
	handleCountryChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedStoragelot, {country: event.target.value}));
	}
	
	handleStateChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedStoragelot, {state: event.target.value}));
	}
	
	
	handleCityChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedStoragelot, {city: event.target.value}));
	}
	
	handleAddress2Change(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedStoragelot, {address2: event.target.value}));
	}
	
	handleAddress1Change(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedStoragelot, {address1: event.target.value}));
	}
	
	/* handleCompanyNumberChange(event) {
			 //event.preventDefault();
			 this.setState(Object.assign(this.state.selectedStoragelot,{firstName:event.target.value}));
	 }
			 */
	
	handleNameChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedStoragelot, {name: event.target.value}));
	}
	
	/*handleCompanyNameChange(event) {
			//event.preventDefault();
			this.setState(Object.assign(this.state.selectedStoragelot,{accountName:event.target.value}));
	}*/
	
	handleEmailChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedStoragelot, {email: event.target.value}));
	}
	
	handleCompanyChange(event) {
		let {loadStoragelotsData} = this.props;
		//event.preventDefault();
		this.setState({selectedCompany: event.target.value});
		loadStoragelotsData(DEFAULT_VESPAAN_SERVER.url, event.target.value.id);
		this.setState({numberShrink: true});
	}
	
	handleStateSelectionChange(event) {
		//let { loadCompanypropertysData  } = this.props;
		//event.preventDefault();
		this.setState({selectedState: event.target.value});
		//loadCompanypropertysData(DEFAULT_VESPAAN_SERVER.url,event.target.value.id );
		this.setState({numberShrink: true});
	}
	
	handleCountrySelectionChange(event) {
		//let { loadCompanypropertysData  } = this.props;
		//event.preventDefault();
		this.setState({selectedCountry: event.target.value});
		//loadCompanypropertysData(DEFAULT_VESPAAN_SERVER.url,event.target.value.id );
	}
	
	handleFaxChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedStoragelot, {fax: event.target.value}));
		this.setState({numberShrink: true});
	}
	
	handleTypeChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedStoragelot, {type: event.target.value}));
		this.setState({numberShrink: true});
	}
	
	handleTimeZoneChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedStoragelot, {timezone: event.target.value}));
		this.setState({numberShrink: true});
	}
	
	handleLogoChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedStoragelot, {companylogolink: event.target.value}));
		this.setState({numberShrink: true});
	}
	
	handleWebChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedStoragelot, {webpagelink: event.target.value}));
		this.setState({numberShrink: true});
	}
	
	handlePhoneChange(event) {
		//event.preventDefault();
		this.setState(Object.assign(this.state.selectedStoragelot, {phone: event.target.value}));
		this.setState({numberShrink: true});
	}
	
	
	handleLocationChange(event) {
		//event.preventDefault();
		this.setState({selectedLocation: event.target.value});
		//this.setState({selectedVideoControllerName: event.target.value.displayName});
	}
	
	
	clearFields = (e) => {
		e.preventDefault();
		this.setState(state => ({
			inputFieldShrinkState: true
		}));
		
		
		var tempSelectedStorage = Object.assign({}, this.state.selectedStoragelot);
		Object.keys(tempSelectedStorage).map((key, index) => {
			tempSelectedStorage[key] = "";
		});
		console.log("The storage lot is ");
		console.log(tempSelectedStorage);
		this.setState({selectedStoragelot: tempSelectedStorage})
	};
	
	renderErrorFiled(data) {
	
	
	}
	
	refresh(event) {
		let {loadStoragelotsData} = this.props;
		loadStoragelotsData(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompany.id);
	}
	
	getListOfStoragelots() {
		let tempArray = this.state.storagelotsArray; //this.props.storagelotsArray;
		let returnArray = [];
		if (tempArray) {
			returnArray = tempArray.map((s) => {
				s.editMode = false;
				return (< CardStorageLotInformation
					info={s}
					onEdit={this.editRecord}
					onDelete={this.deleteRecord(s.id)}> < /CardStorageLotInformation>);
			});
		}
		return (returnArray);
	}
	
	
	//This is for making teh police cards expanadble.
	getListOfSrorageInformationExpandable() {
		let tempArray = this.state.storagelotsArray; //this.props.towjobsArray;
		let returnArray = [];
		if (tempArray) {
			returnArray = tempArray.map((s) => {
				s.editMode = false;
				
				return (<ExpandableStorageLotInformation info={s} key={s.id} onEdit={this.editRecord}
				                                         onVehicleOwnerText={this.vehicleOwnerTextMode}
				                                         onTowAgentText={this.towAgentTextMode}
				                                         onDelete={this.deleteRecord}></ExpandableStorageLotInformation>);
			});
			//Duplicating array for testing only.
			//returnArray = returnArray.concat(returnArray);
			
		}
		return (returnArray);
	}
	
	getListOfCompaniesForSelection() {
		let tempArray = this.props.companysArray;
		let returnArray = [];
		if (tempArray) {
			returnArray = tempArray.map((s) => {
				return (< MenuItem
					key={s.id}
					value={s}> {s.name} < /MenuItem>);
				//return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
			});
		}
		return (returnArray);
	}
	
	
	
	
	render() {
		const {classes} = this.props;
		let usStates = MainConstants.getUSStates();
		let canStates = MainConstants.getCanadaStates();
		let availableCountries = MainConstants.getCountries();
		this.storageCardList = this.getListOfSrorageInformationExpandable();//this.getListOfStoragelots();
		this.companySelectList = this.getListOfCompaniesForSelection();
		return (
			< React.Fragment>
				< Typography
					variant="h6"
					gutterBottom>
					Storage
					Lot
					Information
				< /Typography>
				< Grid
					container
					spacing={24}>
					< Grid item xs={12} sm={12}>
						
						< Grid container>
							
							< Grid
								item
								xs={6}
								sm={6}>
								{/* < FormControl className = {classes.formControl}  required fullWidth >
                    < InputLabel htmlFor = "age-simple" > Location < /InputLabel>
                        < Select ref = {c => this.mySelect = c} value = {this.state.selectedLocation} onChange = {this.handleLocationChange}
                        inputProps = { { name: 'location', id : 'location', } } >
                        {this.props.locationsArray.map(n => (<MenuItem value= {n}   ref={n.id} inputProps = { { name: n.id , id :n.id  } } >{n.name}</MenuItem>))}

                        < /Select>
                < /FormControl>
                */
								}
								
								{/*
            <Grid container >
                <Grid item xs={5} sm={5} >
                    <TextField required id="number" name="number"  label="Number"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState || this.state.numberShrink  }}  value={this.state.selectedStoragelot.accountNumber} onChange={this.handleNumberChange}/>
                </Grid>
                <Grid item xs={2} sm={2} >
                </Grid>
                <Grid item xs={5} sm={5} >
                    <TextField required id="name" name="name"  label="Name on the account"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedStoragelot.accountName} onChange={this.handleCompanyNameChange}/>
                </Grid>
            </Grid>
            */
								}
								
								<
									Grid
									container>
									< Grid
										item
										xs={5}
										sm={5}>
										< TextField
											required
											id="companyname"
											name="companyname"
											label="Storage Lot Name"
											fullWidth
											InputLabelProps={
												{
													shrink: this.state.inputFieldShrinkState
												}
											}
											value={this.state.selectedStoragelot.name}
											onChange={this.handleNameChange}
										/>
									< /Grid>
									< Grid
										item
										xs={2}
										sm={2}>
									< /Grid>
									< Grid
										item
										xs={5}
										sm={5}>
										< FormControl
											className={classes.formControl}>
											< InputLabel
												htmlFor="age-helper"> Select Tow Company < /InputLabel>
											< Select
												value={this.state.selectedCompany}
												onChange={this.handleCompanyChange}
												useDefault={true}
												defaultValue={this.state.selectedCompany.name}
											>
												
												{
													this.companySelectList
												}
											
											</Select>
											{/*   < FormHelperText > Select
        a
        Company < /FormHelperText>
        */}
										< /FormControl>
									< /Grid>
								< /Grid>
								
								< Grid
									item
									xs={12}>
									< TextField
										required
										id="address1"
										name="address1"
										label="Address line 1"
										fullWidth
										InputLabelProps={
											{
												shrink: this.state.inputFieldShrinkState
											}
										}
										value={this.state.selectedStoragelot.address1}
										onChange={this.handleAddress1Change}
									/>
								< /Grid>
								< Grid
									item
									xs={12}>
									< TextField
										id="address2"
										name="address2"
										label="Address line 2"
										fullWidth
										InputLabelProps={
											{
												shrink: this.state.inputFieldShrinkState
											}
										}
										value={this.state.selectedStoragelot.address2}
										onChange={this.handleAddress2Change}
									/>
								< /Grid>
								< Grid container>
									
									< Grid item xs={5} sm={5}>
										< TextField
											required
											id="city"
											name="city"
											label="City"
											fullWidth
											InputLabelProps={
												{
													shrink: this.state.inputFieldShrinkState
												}
											}
											value={this.state.selectedStoragelot.city}
											onChange={this.handleCityChange}
										/>
									< /Grid>
									
									
									< Grid
										item
										xs={2}
										sm={2}>
									< /Grid>
									<Grid item xs={5} sm={5}>
										<FormControl className={classes.formControl}>
											<InputLabel htmlFor="age-helper">State</InputLabel>
											<Select value={this.state.selectedState}
											        onChange={this.handleStateSelectionChange}
											        inputProps={{
												        name: 'state',
												        id: 'state-helper',
											        }}
											>
												
												{(this.state.selectedCountry == "U.S.A") && (usStates)}
												{(this.state.selectedCountry != "U.S.A") && (canStates)}
											
											
											</Select>
											{/* <FormHelperText>Select a State </FormHelperText> */}
										</FormControl>
									
									</Grid>
									
									< Grid
										item
										xs={5}
										sm={5}>
										< TextField
											required
											id="zip"
											name="zip"
											label="Zip / Postal code"
											fullWidth
											InputLabelProps={
												{
													shrink: this.state.inputFieldShrinkState
												}
											}
											value={this.state.selectedStoragelot.zipcode}
											onChange={this.handleZipcodeChange}
										/>
									< /Grid>
									
									
									< Grid
										item
										xs={2}
										sm={2}>
									< /Grid>
									
									
									<Grid item xs={5} sm={5}>
										{/*<TextField required id="city" name="city" label="City" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedProperty.city} onChange={this.handleCityChange}/>
                                       */}
										<FormControl className={classes.formControl}>
											<InputLabel htmlFor="age-helper">Country</InputLabel>
											<Select value={this.state.selectedCountry}
											        onChange={this.handleCountrySelectionChange}
											        inputProps={{
												        name: 'country',
												        id: 'country-helper',
											        }}
											>
												
												{availableCountries}
											
											</Select>
										
										</FormControl>
									</Grid>
									
									
									< Grid item xs={5} sm={5}>
										<InputMask mask="(999) 999-9999" value={this.state.selectedStoragelot.phone}
										           onChange={this.handlePhoneChange}>
											{() => < TextField required id="phone" name="phone" label="Phone" fullWidth
											                   InputLabelProps={{shrink: this.state.inputFieldShrinkState}}/>}
										</InputMask>
									< /Grid>
									<Grid item xs={2} sm={2}>
									</Grid>
									
									<Grid item xs={5} sm={5}>
										<TextField required id="email" name="email" type="email" label="Email"
										           placeholder="email@example.com" fullWidth
										           InputLabelProps={{shrink: this.state.inputFieldShrinkState}}
										           value={this.state.selectedStoragelot.email} onChange={this.handleEmailChange}/>
									</Grid>
									
									
									{/*  It didn't work.
                        <Grid item xs={5} sm={5}>
                            <InputMask mask="**************************************@********************************************************"
                            value={this.state.selectedProperty.email} onChange={this.handleEmailChange}
                            >
                            {()=> <TextField  required id="email"  name="email"  label="Email"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}    /> }

                        </InputMask>
                        </Grid>
                        */}
									
									
									<Grid item xs={5} sm={5}>
										<InputMask mask="(999) 999-9999" value={this.state.selectedStoragelot.fax}
										           onChange={this.handleFaxChange}>
											{() => <TextField required id="phone" name="Fax" label="Fax" fullWidth
											                  InputLabelProps={{shrink: this.state.inputFieldShrinkState}}/>}
										</InputMask>
									</Grid>
									< Grid
										item
										xs={2}
										sm={2}>
									< /Grid>
									
									< Grid
										item
										xs={5}
										sm={5}>
									< /Grid>
									
									
									< Grid
										item
										xs={5}
										sm={5}>
									< /Grid>
									< Grid
										item
										xs={2}
										sm={2}>
									< /Grid>
									
									< Grid
										item
										xs={5}
										sm={5}>
										{/*
                <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="age-helper">Company</InputLabel>
                        <Select
                            value={this.state.selectedCompany}
                            onChange={this.handleCompanyChange}
                            inputProps={{
                                name: 'age',
                                id: 'age-helper',
                            }}
                        >

                            {this.companySelectList}

                        </Select>
                    <FormHelperText>Select a Company </FormHelperText>
                </FormControl>
                */
										}
									< /Grid>
									
									
									< Grid
										item
										xs={5}
										sm={5}>
									< /Grid>
									< Grid
										item
										xs={2}
										sm={2}>
									< /Grid>
									
									< Grid
										item
										xs={5}
										sm={5}>
									< /Grid>
									
									< Grid
										item
										xs={5}
										sm={5}>
									< /Grid>
									< Grid
										item
										xs={2}
										sm={2}>
									< /Grid>
									
									< Grid
										item
										xs={5}
										sm={5}>
										{/* empty for now we can later*/}
									< /Grid>
									
									
									< Grid item xs={6} sm={6}>
										{((this.state.selectedStoragelot.id === undefined) || (this.state.selectedStoragelot.id === "")) && (
										< Button
											variant="contained"
											color="primary"
											onClick={this.handleSubmit}
											className={classes.button}>
											Add
											Storage
											lot
										< /Button>)}
									< /Grid>
									< Grid
										item
										xs={6}
										sm={6}>
										{( (this.state.selectedStoragelot.id !=='')) &&(
											< Button
											variant="contained"
											color="primary"
											onClick={this.handleUpdate}
											className={classes.button}>
											Update
											Storage
											lot
										< /Button>)}
									< /Grid>
									< Grid
										item
										xs={6}
										sm={6}>
										< Button
											variant="contained"
											color="primary"
											onClick={this.clearFields}
											className={classes.button}>
											Clear
											Fields
										< /Button>
									< /Grid>
									< Grid
										item
										xs={6}
										sm={6}>
										< Button
											variant="contained"
											color="primary"
											onClick={this.refresh}
											className={classes.button}>
											Refresh
										< /Button>
									< /Grid>
								< /Grid>
							< /Grid>
							< Grid
								item
								xs={1}
								sm={1}>
							< /Grid>
							< Grid
								item
								xs={5}
								sm={5}>
								{/*<DynamicTable  data={this.props.companysArray}  onEdit={this.editRecord}  onDelete={this.deleteRecord}> </DynamicTable> */}
								<Typography variant="h6" gutterBottom>
									There are {this.props.storagelotsArray.length} Storage Lots in your profile.
								</Typography>
								
								< GridList
									cellHeight={100}
									className={classes.gridList}>
									{this.storageCardList}
								< /GridList>
							< /Grid>
						< /Grid>
						
						
						< Grid container>
							{(this.props.errorCMsg) && (this.props.errorCMsg.message) && (
								< Grid
									item
									xs={12}>
									< TextField
										error
										id="outlined-error"
										label="Error - Operation Failed"
										value={" message = " + this.props.errorCMsg.message + " details = " + this.props.errorCMsg.details + " Time = " + this.props.errorCMsg.timestamp}
										className={classes.textField}
										margin="normal"
										variant="outlined"
										disabled={true}
										multiline={true}
									/>
								< /Grid>)
							}
							{/*
                    {  !this.props.errorCMsg && (
                    <Grid item xs={12}   >
                        <TextField error id="outlined-error" label="Great! - Operation Success" value= "Nothing here"
                        className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                    </Grid>)
                    }
                    */
							}
						<
        /Grid>
					< /Grid>
					
					{/* This is for submit event error/success display */}
					<Dialog
						open={this.state.showStoragelotSavedDialog}
						onClose={this.handleClickShowSavedStoragelotClose}
						scroll={'paper'}
						classes={{
							paper: classes.formControl2,
						}}
						aria-labelledby="scroll-dialog-title"
						aria-describedby="scroll-dialog-description"
						maxWidth="xl"
					>
						<DialogTitle id="scroll-dialog-title">Storagelot Information</DialogTitle>
						<DialogContent id="farshids" dividers="paper">
							
							{(this.props.errorCMsg.status == 200) && (<div>
								The Operation was SUCCESSFUL! Please refresh the list by pressing the refresh button.
							</div>)}
							{(this.props.errorCMsg.status != 200) && (this.props.errorCMsg.status != null) && (<div>
								The Operation FAILED, please try again!
								- {this.props.errorCMsg.status} - {this.props.errorCMsg.statusText}
							</div>)}
						
						</DialogContent>
						<DialogActions>
							{/*
																										<Tooltip title="Selected entities will receive police notice">
																											<Button  color="primary" onClick={this.sendEmail}>Send EMAIL</Button>
																										</Tooltip>
																										*/}
							
							<Button onClick={this.handleClickShowSavedStoragelotClose} color="secondary">Close</Button>
						</DialogActions>
					</Dialog>
				
				< /Grid>
			< /React.Fragment>
		)
			;
	}//end of render
	
	
	editRecord(singleRowData) {
		this.setState({inputFieldShrinkState: true});
		this.setState({selectedStoragelot: singleRowData});
		this.setState({selectedState: singleRowData.state});
		this.setState({selectedCountry: singleRowData.country});
		
		
		// selectedState: "Massachusetts"
		//We need to change the seleted Location as well.
		//let tempLocation = this.props.locationsArray.find(x => x.locationId == singleRowData.locationId );
		
		//this.setState({selectedLocation:tempLocation });
		
	}
	
	
	deleteRecord(argProcessId) {
		//alert('I am deleting ' + argCameraId);
		let {deleteAStoragelot, loadStoragelotsData} = this.props;
		deleteAStoragelot(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompany.id, argProcessId);
		//loadStoragelotsData(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompany.id);
	}
	
	
	componentWillMount() {
		let {loadStoragelotsData, loadCompanysData} = this.props;
		//loadStoragelotsData(DEFAULT_VESPAAN_SERVER.url);
		//loadLocationsData("http://localhost:9065/" );
		
		loadCompanysData(DEFAULT_VESPAAN_SERVER.url);
		
		this.setState({
			errorCMsg: {}
		});
		
		if ((this.props.companysArray != null) && (this.props.companysArray.length >= 1)) {
			this.setState({selectedCompany: this.props.companysArray[0]});
			loadStoragelotsData(DEFAULT_VESPAAN_SERVER.url, this.props.companysArray[0].id);
		}
	}
	
	componentDidMount() {
		/*if ((this.props.companysArray != null) && (this.props.companysArray.length >= 1)) {
				this.setState({selectedCompany: this.props.companysArray[0]});
		}*/
		
	}
	
	componentWillReceiveProps(nextProps) {
		// if (this.props.storagelotsArray !== nextProps.storagelotsArray) {
		this.setState({
			storagelotsArray: nextProps.storagelotsArray
		});
		//}
		if ((nextProps != null) && (nextProps.companysArray != null) && (nextProps.companysArray.length >= 1) && (this.props.companysArray !== nextProps.companysArray)) {
			this.setState({selectedCompany: nextProps.companysArray[0]});
			//selectACompany(nextProps.companysArray[0].id);
		}
		if (nextProps.errorCMsg.status != null) {
			if (nextProps.errorCMsg.status != null) {
				this.handleClickShowSavedStoragelot();
			}
		}
	}
	
	
}//end of class

StorageLotInfoForm.propTypes = {
	classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
	return {
		storagelotsArray: state.storagelot.storagelotsArray,
		storageDeleteResponse: state.storagelot.deleteStoragelotResp,
		storageSaveResponse: state.storagelot.saveStoragelotResp,
		companysArray: state.company.companysArray,
		//locationsArray:state.location.locationsArray,
		//vcArray:state.videocontroller.vcArray,
		//camerasArray:state.camera.camerasArray,
		errorCMsg: state.storagelot.errorCMsg,
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		loadStoragelotsData: loadStoragelotsData,
		deleteAStoragelot: deleteAStoragelot,
		saveAStoragelot: saveAStoragelot,
		updateAStoragelot: updateAStoragelot,
		loadCompanysData: loadCompanysData,
		clearStoragelotErrorMsg: clearStoragelotErrorMsg,
		//addStoragelotToArray:addStoragelotToArray,
		
		
	}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(StorageLotInfoForm));
